import { render, staticRenderFns } from "./testSend.vue?vue&type=template&id=1907c9de&"
import script from "./testSend.vue?vue&type=script&lang=js&"
export * from "./testSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports